import axios from 'axios';

export default {
  getAllMasterData(params = {}) {
    return axios.get('/v1/audit-trail', { params });
  },
  detailMasterData(id) {
    return axios.get(`/v1/audit-trail/${id}`);
  },
  getAllUserManagement(params = {}) {
    return axios.get('/v1/audit-trail/user', { params });
  },
  detailUserManagement(id) {
    return axios.get(`/v1/audit-trail/user/${id}`);
  },
  getLockBudget(params = {}) {
    return axios.get('/v1/audit-trail/budget-period/list', { params });
  },
  getHierarchy(params = {}) {
    return axios.get('/v1/audit-trail/hierarchy/list', { params });
  },
  getGroup(params = {}) {
    return axios.get('/v1/audit-trail/group/list', { params });
  },
  getLogin(params = {}) {
    return axios.get('/v1/audit-trail/login/list', { params });
  }
};
